import { LOCAL_STORAGE_KEYS } from 'lib/common/constants/localStorageKeys';

export default function resetRelatedCallsInStorage() {
  localStorage.setItem(LOCAL_STORAGE_KEYS.RELATED_CALLS_ID, '');
  localStorage.setItem(LOCAL_STORAGE_KEYS.RELATED_CALLS_LAST_CALL_WITH, '');
}
